import React, { Component } from 'react'
import * as actions from "../actions";

const LikePost = React.createClass({
  shouldComponentUpdate(nextProps, nextState) {
    return this.props.liked !== nextProps.liked;
  },
  getInitialState: function() {
    return {clicked: false};
  },
  render: function() {
    return (
      <a
        onClick={this.handleClick}
        className={`like-post ${this.props.liked ? "liked" : ""} ${this.state.clicked ? "like-clicked" : ""}`}
      >
        <i className="icon-heart"></i> {this.props.liked ? "Unlike" : "Like"}
      </a>
    )
  },
  handleClick: function(e) {
    e.preventDefault();
    this.props.liked ? this.unlikePost() : this.likePost();
    this.setState({clicked: true});
  },
  likePost: function() {
    const { postId, replyId, liked } = this.props;
    replyId ? actions.likeReply(postId, replyId) : actions.likePost(postId);
  },
  unlikePost: function() {
    const { postId, replyId, liked } = this.props;
    replyId ? actions.unlikeReply(postId, replyId) : actions.unlikePost(postId);
  }
})

export default LikePost;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/posts/components/like-post.es6